import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 98804 98805"
    {...props}
  >
    <path
      d="m71126 40424 13236-25927-25947 13196L49441 0l-9017 27680-25927-13236 13194 25948L0 49364l27677 9017-13236 25928 25948-13195 8975 27691 9017-27678 25926 13235-13196-25947 27693-8974z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
